/*
Copyright Captcha, Inc. 2004-2021. All rights reserved.

BotDetect, BotDetect CAPTCHA, Lanap, Lanap CAPTCHA, Lanap BotDetect, 
Lanap BotDetect CAPTCHA, Lanapsoft, Lanapsoft CAPTCHA, 
Lanapsoft BotDetect, Lanapsoft BotDetect CAPTCHA, and Lanap Software 
are trademarks of Captcha, Inc. All other product, brand, and company 
names are mentioned for identification purposes only and are trademarks 
or registered trademarks of their respective owners.

Captcha, Inc. - formerly: Lanapsoft, Inc. / Lanap, Inc.
*/

// get captcha endpoint handler from configued captchaEndpointPath value,
// the expected result will be:
// simple-captcha-endpoint.ashx -- for asp.net backend
// simple-captcha-endpoint -- for java backend
// simple-captcha-endpoint.php -- for php backend
function getCaptchaEndpointHandler(configuredCaptchaEndpointPath) {
  let splited = configuredCaptchaEndpointPath.split('/');
  return splited[splited.length - 1];
}

// get backend base url from configued captchaEndpointPath value
function getBackendBaseUrl(configuredCaptchaEndpointPath, captchaEndpointHandler) {
  let lastIndex = configuredCaptchaEndpointPath.lastIndexOf(captchaEndpointHandler);
  return configuredCaptchaEndpointPath.substring(0, lastIndex);
}

// change relative to absolute urls in captcha html markup
export default function changeRelativeToAbsoluteUrls(originalCaptchaHtml, configuredCaptchaEndpointPath) {
  let captchaEndpointHandler = getCaptchaEndpointHandler(configuredCaptchaEndpointPath);
  let backendUrl = getBackendBaseUrl(configuredCaptchaEndpointPath, captchaEndpointHandler);
  let relativeUrls = originalCaptchaHtml.match(/(src|href)=\"([^"]+)\"/g);
  let relativeUrl, relativeUrlPrefixPattern, absoluteUrl,
      changedCaptchaHtml = originalCaptchaHtml;

  for (let i = 0; i < relativeUrls.length; i++) {
    relativeUrl = relativeUrls[i].slice(0, -1).replace(/src=\"|href=\"/, '');
    relativeUrlPrefixPattern = new RegExp(".*" + captchaEndpointHandler);
    absoluteUrl = relativeUrl.replace(relativeUrlPrefixPattern, backendUrl + captchaEndpointHandler);
    changedCaptchaHtml = changedCaptchaHtml.replace(relativeUrl, absoluteUrl);
  }

  return changedCaptchaHtml;
}
